import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  TemplateRef,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconRegistry } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'stena-toolbar',
  providers: [MatIconRegistry],
  templateUrl: './stena-toolbar.component.html',
  styleUrls: ['./stena-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatToolbarModule, MatButtonModule, MatMenuModule],
})
export class StenaToolbarComponent {
  // Custom templates
  @Input() headerItemTemplates: { [key: string]: TemplateRef<unknown> } = {};
  @Input() subLinkTemplate?: TemplateRef<unknown>;
  @Input() showSublinks?: boolean;
  @Input() headers: string[] = [];
  @Input() showMenuButton = true;

  @Input() companyLogoSrc? = 'assets/stena.svg';

  trackByHeaders(i: number, header: string) {
    return header;
  }
}
